"use client"

import {Moon, Sun} from "lucide-react"
import {useTheme} from "next-themes"
import {useEffect, useState} from "react"

import {cn} from "@/lib/cn"

import {iconButtonClassName} from "./icon-button"

/** Dark/light switch. Renders a stable placeholder until mounted (SSR-safe). */
export const ThemeToggle = ({className}: {className?: string}) => {
  const [mounted, setMounted] = useState(false)
  const {resolvedTheme, setTheme} = useTheme()

  useEffect(() => setMounted(true), [])

  const isDark = resolvedTheme === "dark"

  return (
    <button
      type="button"
      aria-label={mounted && isDark ? "Switch to light theme" : "Switch to dark theme"}
      onClick={() => setTheme(isDark ? "light" : "dark")}
      className={cn(iconButtonClassName, className)}
    >
      {mounted ? (
        isDark ? (
          <Sun className="size-4" />
        ) : (
          <Moon className="size-4" />
        )
      ) : (
        <span className="size-4" />
      )}
    </button>
  )
}
